import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
export default {
  mixins: [loadMoreList, tool, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      pagingReqFn: "",
      paramsData: {
        isMustAppid: 1
      },
      loginType: ''
    };
  },
  created: function created() {},
  methods: {
    init: function init(data, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.loginType = type;

                if (type == 1) {
                  _this.pagingReqFn = "accountList";
                } else if (type == 2) {
                  _this.pagingReqFn = "emailList";
                } else if (type == 3) {
                  _this.pagingReqFn = "phoneList";
                } else if (type == 4) {
                  _this.pagingReqFn = "oauthList";
                } else if (type == 5) {
                  _this.pagingReqFn = "visitorList";
                } else if (type == 6) {
                  _this.pagingReqFn = "userRealNameList";
                }

                _this.paramsData.appid = data.appid;
                _this.paramsData.user_id = data.user_id;

                _this.getList();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};